export var ExtendedCallStatus;
(function (ExtendedCallStatus) {
    ExtendedCallStatus[ExtendedCallStatus["IN_IVR"] = 10] = "IN_IVR";
    ExtendedCallStatus[ExtendedCallStatus["IN_QUEUE"] = 20] = "IN_QUEUE";
    ExtendedCallStatus[ExtendedCallStatus["RESERVED"] = 30] = "RESERVED";
    ExtendedCallStatus[ExtendedCallStatus["INITIATED"] = 40] = "INITIATED";
    ExtendedCallStatus[ExtendedCallStatus["RINGING"] = 50] = "RINGING";
    ExtendedCallStatus[ExtendedCallStatus["IN_PROGRESS"] = 60] = "IN_PROGRESS";
    ExtendedCallStatus[ExtendedCallStatus["COMPLETED"] = 70] = "COMPLETED";
    ExtendedCallStatus[ExtendedCallStatus["COMPLETED_IN_IVR"] = 71] = "COMPLETED_IN_IVR";
    ExtendedCallStatus[ExtendedCallStatus["FORWARDED"] = 72] = "FORWARDED";
    ExtendedCallStatus[ExtendedCallStatus["VOICEMAIL"] = 74] = "VOICEMAIL";
    ExtendedCallStatus[ExtendedCallStatus["VOICEMAIL_PENDING"] = 75] = "VOICEMAIL_PENDING";
    ExtendedCallStatus[ExtendedCallStatus["TRANSFERRED_TO_NUMBER"] = 73] = "TRANSFERRED_TO_NUMBER";
    ExtendedCallStatus[ExtendedCallStatus["BUSY"] = 80] = "BUSY";
    ExtendedCallStatus[ExtendedCallStatus["FAILED"] = 90] = "FAILED";
    ExtendedCallStatus[ExtendedCallStatus["NO_ANSWER"] = 100] = "NO_ANSWER";
    ExtendedCallStatus[ExtendedCallStatus["CANCELED"] = 110] = "CANCELED";
    ExtendedCallStatus[ExtendedCallStatus["EXPIRED"] = 120] = "EXPIRED";
    ExtendedCallStatus[ExtendedCallStatus["TRANSFERRED_TO_QUEUE"] = 130] = "TRANSFERRED_TO_QUEUE";
    ExtendedCallStatus[ExtendedCallStatus["ABANDONED"] = 140] = "ABANDONED";
    ExtendedCallStatus[ExtendedCallStatus["HUNG_UP_IN_QUEUE"] = 150] = "HUNG_UP_IN_QUEUE";
    ExtendedCallStatus[ExtendedCallStatus["HUNG_UP_IN_IVR"] = 160] = "HUNG_UP_IN_IVR";
    ExtendedCallStatus[ExtendedCallStatus["TRANSFERRED_TO_IVR"] = 170] = "TRANSFERRED_TO_IVR";
})(ExtendedCallStatus || (ExtendedCallStatus = {}));
//# sourceMappingURL=extended-call-status.js.map